import { observable } from "mobx";
import {getByAtribute} from "../../../utils/formatar";
import AcheService from "../../../services/AcheService";
import EmpresaGloboService from "../../../services/EmpresaGloboService";

export default class AcheStore {

    @observable acheLista;
    @observable itemSelecionado;
    @observable itemClone;
    @observable sindicatos;
    @observable empresasGlobo;
    @observable modalSubmitted;
    @observable loading;

    constructor(modalStore) {
        this.modalStore = modalStore;
        this.modalSubmitted = false;
        this.acheLista = [];
        this.sindicatos = [{ value: 'JORNALISTA', label: 'JORNALISTA' }, { value: 'RADIALISTA', label: 'RADIALISTA' }];
        this.empresasGlobo = [];
        this.resetItemSelecionado();
        this.acheService = new AcheService();
        this.empresaGloboService = new EmpresaGloboService();
    }

    resetItemSelecionado() {
        this.itemSelecionado = {
            id: 0,
            sindicato: null,
            empresaGloboId: null,
            empresaGlobo: {
                id: 0,
                nome: ""
            },
            aplicarAche: true,
            percentualAche: 0,
            percentualSalarioBase: 0,
            jornadaContratual: 0,
            jornadaAche: 0
        };
    }

    carregarLista() {
        this.loading = true;

        const loadingPromises = Promise.all([
            this.acheService.list().then(response => {
                this.acheLista = response.data;
            }).catch(error => {
                console.log(error);
            }),
            this.empresaGloboService.list().then(response => {
                this.empresasGlobo = response.data;
            }).catch(error => {
                console.log(error);
            })
        ]);
        loadingPromises.then(
            () => {
                this.loading = false;
            }
        ).catch(
            (error) => this.loading = false
        )
    }

    toggleAplicarAche() {
        this.itemSelecionado.aplicarAche = !this.itemSelecionado.aplicarAche;
    }

    setEmpresaGloboId(value) {
        this.itemSelecionado.empresaGloboId = value;
    }

    setSindicato(value) {
        this.itemSelecionado.sindicato = value;
    }

    setPercentualAche(value) {
        this.itemSelecionado.percentualAche = value;
    }

    setPercentualSalarioBase(value) {
        this.itemSelecionado.percentualSalarioBase = value;
    }

    setJornadaContratual(value){
        this.itemSelecionado.jornadaContratual = value;
    }

    setJornadaAche(value){
        this.itemSelecionado.jornadaAche = value;
    }

    setLista(value) {
        this.acheLista = value;
    }


    preencherModal(row){
        if(row) {
            this.itemSelecionado = Object.assign({}, row);
        } else {
            this.resetItemSelecionado();
        }
    }

    editar() {
        let tabelaIndex = this.acheLista.findIndex((tabelaItem) => tabelaItem.id === this.itemSelecionado.id);
        this.itemSelecionado.empresaGlobo = getByAtribute(this.empresasGlobo, this.itemSelecionado.empresaGloboId, "id");

        return this.acheService.edit(this.itemSelecionado.id, this.itemSelecionado).then(response => {
            this.acheLista[tabelaIndex] = response.data;
        })
    }

    cadastrar() {
        this.itemSelecionado.empresaGlobo = getByAtribute(this.empresasGlobo, this.itemSelecionado.empresaGloboId, "id");

        return this.acheService.save(this.itemSelecionado).then(response => {
            this.acheLista.push(response.data);
        });
    }

    remover() {
        let tabelaIndex = this.acheLista.findIndex((tabelaItem) => tabelaItem.id === this.itemSelecionado.id);
        let modal = this.modalStore;

        return this.acheService.delete(this.itemSelecionado.id).then(response => {
            this.acheLista.splice(tabelaIndex, 1);
            modal.toggleModal()
        }).catch(error => {
            modal.setSubmitMensagemErro(error.response.data.message)
        });
    }
}